module.exports = "/assets/fff820d6f00cfa48f136d014c24b9419.png";